import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
// import SampleOrder from './SampleOrder';
import { Tabs } from 'antd';
import { GetSPCOADetail } from '../../../../API/GetData';
import COADetails from './COA';
import COASample from './COASample';
import { decrypt, encrypt } from '../../../../Utils/CryptoHelper';
// import { GetSPOrderDetail } from '../../../../API/GetData';
// import OrderDetail from './OrderDetail';

const COADetail = () => {
    const params = useParams();
    const navigate = useNavigate();
    // const { accountid, code } = params;

    let accountid = params.accountid;
    let code = params.code;

    useEffect(() => {
        if (accountid.startsWith("AC") || code.startsWith("COA")) {
            const encryptedAccountId = encodeURIComponent(encrypt(accountid));
            const encryptedCode = encodeURIComponent(encrypt(code));

            navigate(`/coa/${encryptedAccountId}/${encryptedCode}`, { replace: true });
        }
    }, [accountid, code, navigate]);

    const DecAccountId = decrypt(decodeURIComponent(accountid));
    const DecCode = decrypt(decodeURIComponent(code));

    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await GetSPCOADetail(DecAccountId, DecCode);
                setDataSource(res);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, [DecAccountId, DecCode]);

    const items = [
        {
            key: '1',
            label: 'COA',
            children: <COADetails dataSource={dataSource.COA} />,
        },
        {
            key: '2',
            label: 'COA Sample',
            children: <COASample dataSource={dataSource.COASample} />,
        },
    ];

    return (
        <div className="bg-white p-4 rounded-md">
            <div className="flex flex-col mb-2">
                <p className="text-xl font-medium">DETAIL COA</p>
                <p className="text-lg font-medium text-second">{dataSource?.COA?.COACode}</p>
            </div>
            <Tabs defaultActiveKey="1" items={items} />
        </div>
    )
}

export default COADetail